// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Region Get
/**
 *
 * @param {{params: object, query: { search: string, companyId: string, page: number, limit: number  }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Region.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Region Detail
/**
 *
 * @param {{params: object, query: { search: string, companyId: string, page: number, limit: number  }}} option
 *
 * @returns
 */
export const Details = async (option) => {
  const response = await $api.get(Endpoints.Region.Details(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Region Create
/**
 *
 * @param {{"name": "string"}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Region.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Region Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Region.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Region Update
/**
 *
 * @param {{"name": "string", isActive: boolean}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Region.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Region Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Region.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Region Get Locations
/**
 *
 * @param {{params: { id: string }, query: object}} option
 *
 * @returns
 */
export const GetLocations = async (option) => {
  const response = await $api.get(Endpoints.Region.GetLocations(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Region Update Locations
/**
 *
 * @param {{ geoJsonIds: string[] }} form
 * @param {{params: { id: string }, query: object}} option
 *
 * @returns
 */
export const UpdateLocations = async (form, option) => {
  const response = await $api.put(
    Endpoints.Region.UpdateLocations(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Region With Locations
/**
 * @param {{ query?: { regionIds?: string[] } }} option
 * @returns
 */
export const WithLocations = async (option = {}) => {
  const regionIds = (option.query?.regionIds || []).filter(Boolean);

  const response = await $api.get(
    Endpoints.Region.WithLocations({
      query: regionIds.length ? { regionIds: regionIds.join(",") } : {},
    })
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Details,
  Create,
  GetById,
  Update,
  Delete,
  GetLocations,
  UpdateLocations,
  WithLocations,
};
